module.exports = __webpack_public_path__ + "imgs/leafwell1.283eb9eaccc601c1d8d2a59be05dbed6.svg";